$(document).ready(function() {
    const overlay_text = $('.text_normal_version_overlay, .text_easy_version_overlay');
    const overlay_text_toggler = $('.overlay_text_toggler');
    const overlay_text_toggler_text = $('.switch_to_normal, .switch_to_easy');


    
    if (overlay_text_toggler.length > 0) {
        overlay_text_toggler.on('click', function(){
            overlay_text.toggleClass('disabled');
            overlay_text_toggler_text.toggleClass('disabled');
        });
    }

    const navbar_text_toggler = $('.text_toggler');
    const navbar_text_toggler_text = $('.to_easy, .to_normal');
    const body_text = $('.text_normal_version_body.easy_active, .text_easy_version_body');

    if ($('.text_easy_version_body').length === 0) {
        navbar_text_toggler.addClass('disabled');
    }
    else {
        navbar_text_toggler.on('click', function () {
            body_text.toggleClass('disabled');
            navbar_text_toggler_text.toggleClass('disabled');
        });
    }
});


